export default "__VITE_ASSET__BLr4fKvm__"